import { leadershipFundamentalsModule } from './modules/leadership-fundamentals';
import { technicalMentoringModule } from './modules/technical-mentoring';
import { stakeholderCommunicationModule } from './modules/stakeholder-communication';
import { projectPlanningModule } from './modules/project-planning';

export const technicalLeadershipCourse = {
  id: 'technical-leadership',
  title: 'Technical Leadership & Team Management',
  description: 'Leadership skills for senior developers and tech leads in enterprise environments',
  level: 'advanced',
  totalDuration: '16 hours',
  image: '/api/placeholder/400/300',
  prerequisites: ['3+ years development experience'],
  learningOutcomes: [
    'Lead technical teams and manage complex projects',
    'Make architectural decisions and technical strategy',
    'Mentor junior developers and conduct effective code reviews',
    'Communicate technical concepts to non-technical stakeholders'
  ],
  modules: [
    { ...leadershipFundamentalsModule, order: 1, estimatedTime: leadershipFundamentalsModule.duration },
    { ...technicalMentoringModule, order: 2, estimatedTime: technicalMentoringModule.duration },
    { ...stakeholderCommunicationModule, order: 3, estimatedTime: stakeholderCommunicationModule.duration },
    { ...projectPlanningModule, order: 4, estimatedTime: projectPlanningModule.duration }
  ]
};